import { WatchDogOverviewContextPanel } from "@/components/hlidaci-pes/watchdog-page/WatchDogOverviewContextPanel";
import { WatchDogOverviewCreatePanel } from "@/components/hlidaci-pes/watchdog-page/WatchDogOverviewCreatePanel";
import { WatchDogOverviewIntroPanel } from "@/components/hlidaci-pes/watchdog-page/WatchDogOverviewIntroPanel";
import { cn } from "@/lib/utils";

export type WatchDogHintWindowBodyPanelsProps = {
  watchDogCount: number;
  activeViewLabel: string;
  activeViewDescription: string;
  isTop?: boolean;
};

export function WatchDogHintWindowBodyPanels({
  watchDogCount,
  activeViewLabel,
  activeViewDescription,
  isTop = false,
}: WatchDogHintWindowBodyPanelsProps) {
  return (
    <div className={cn("gap-3", isTop ? "grid sm:grid-cols-3" : "space-y-3")}>
      <WatchDogOverviewIntroPanel />
      <WatchDogOverviewContextPanel
        watchDogCount={watchDogCount}
        activeViewLabel={activeViewLabel}
        activeViewDescription={activeViewDescription}
      />
      <WatchDogOverviewCreatePanel />
    </div>
  );
}
